import { render, staticRenderFns } from "./suspensionNotice.vue?vue&type=template&id=8ba0bb92"
import script from "./suspensionNotice.vue?vue&type=script&lang=js"
export * from "./suspensionNotice.vue?vue&type=script&lang=js"
import style0 from "./suspensionNotice.vue?vue&type=style&index=0&id=8ba0bb92&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports